import { OnInit } from '@angular/core';
import { LocationsApi } from '@core/api/locations.api';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import { CustomCompileService } from '@core/services/custom-compile.service';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { icon, latLngBounds, marker, tileLayer } from 'leaflet';
import { merge, Subject } from 'rxjs';
import { debounceTime, startWith, switchMap } from 'rxjs/operators';
import { FilterLocationsComponent } from '../../filter/filter-locations.component';
import { PopupMarkerComponent } from './popup-marker.component';
var MapLocationsComponent = /** @class */ (function () {
    function MapLocationsComponent(locationsApi, compile, customMessageService, fuseProgressBarService) {
        this.locationsApi = locationsApi;
        this.compile = compile;
        this.customMessageService = customMessageService;
        this.fuseProgressBarService = fuseProgressBarService;
        this.markerClusterData = [];
        this.options = {
            layers: [tileLayer('https://mt0.google.com/vt/lyrs=m&hl=pt&x={x}&y={y}&z={z}&s=Ga7')],
            zoom: 5
        };
    }
    MapLocationsComponent.prototype.ngOnInit = function () {
        var _this = this;
        merge(this.reload, this.filters.filtersChanged)
            .pipe(startWith({}), debounceTime(500), switchMap(function () { return _this.searchLocations(); }))
            .subscribe(function (data) {
            _this.fuseProgressBarService.hide();
            var locations = [];
            var boundsItems = [];
            data.items.forEach(function (location) {
                var pointer = marker([location.address.coords.latitude, location.address.coords.longitude], {
                    icon: icon({
                        iconSize: [40, 40],
                        iconAnchor: [20, 35],
                        iconUrl: 'assets/images/icons/ic_place_24px.svg',
                        popupAnchor: [0, -35]
                    })
                });
                pointer.bindPopup(_this.compile.compile(PopupMarkerComponent, function (c) {
                    c.instance.location = location;
                    c.instance.reload = function () {
                        _this.reload.next();
                    };
                }));
                boundsItems.push([location.address.coords.latitude, location.address.coords.longitude]);
                locations.push(pointer);
            });
            if (!boundsItems.length) {
                boundsItems.push([-47.186656, -98.472544], [5.664193, -28.775281]);
                _this.customMessageService.error('LOCATIONS.FILTER.NOT_FOUND');
            }
            _this.fitBoundsOptions = latLngBounds(boundsItems);
            _this.markerClusterData = locations;
        });
    };
    MapLocationsComponent.prototype.searchLocations = function () {
        this.fuseProgressBarService.show();
        return this.locationsApi.search(this.filters.filtersChanged.value, { limit: 9999 });
    };
    MapLocationsComponent.prototype.markerClusterReady = function (group) {
        this.markerClusterGroup = group;
    };
    return MapLocationsComponent;
}());
export { MapLocationsComponent };
